<script setup lang="ts">
withDefaults(defineProps<{ width?: string; height?: string }>(), { width: '100%', height: '1em' })
</script>

<template>
  <span
    aria-hidden="true"
    class="inline-block animate-pulse motion-reduce:animate-none rounded-[var(--radius-control)] bg-[color:var(--color-border)]"
    :style="{ width, height }"
  />
</template>
